import { Link } from "react-router-dom";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";
import PublicHeader from "../components/PublicHeader";

const PaymentCancelPage = () => {
  const token = localStorage.getItem("token");
  let isClient = false;
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      isClient = payload.role === "client";
    } catch (_) {}
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/30">
      <PublicHeader />
      <div className="flex items-center justify-center p-4 pt-16">
        <div className="w-full max-w-md">
          <Card className="border-border/50 shadow-xl" data-testid="payment-cancel-card">
            <CardHeader className="text-center">
              <div className="flex justify-center mb-4">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                  <XCircle className="h-8 w-8 text-red-600" />
                </div>
              </div>
              <CardTitle>Paiement annulé</CardTitle>
              <CardDescription>
                Le paiement a été annulé. Aucun montant n'a été débité.
              </CardDescription>
            </CardHeader>
            <CardFooter className="flex justify-center gap-3">
              <Link to="/boutique">
                <Button>Retour à la boutique</Button>
              </Link>
              {token && (
                <Link to={isClient ? "/portal/boutique" : "/pos"}>
                  <Button variant="outline">{isClient ? "Mon espace" : "Caisse"}</Button>
                </Link>
              )}
            </CardFooter>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
